import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import cuentas from "../lib/data.json";

export default function Invest() {
  return (
    <div className="p-4 overflow-x-auto">
      <h2 className="text-xl font-semibold mb-4">Cuentas de Ahorro en Perú</h2>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Producto</TableHead>
            {/* <TableHead>Entidad</TableHead> */}
            <TableHead>TEA</TableHead>
            <TableHead>Mant.</TableHead>
            <TableHead>Ventanilla</TableHead>
            <TableHead>Cajero</TableHead>
            <TableHead>Apertura</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {cuentas.map((cuenta, index) => (
            <TableRow key={index}>
              <TableCell>
                <p className="font-bold">{cuenta["Producto"]}</p>
                <img
                  src={new URL(cuenta.logo, import.meta.url).href}
                  style={{ padding: 10, borderRadius: 10 }}
                ></img>
              </TableCell>
              {/* <TableCell>{cuenta["Entidad"]}</TableCell> */}
              <TableCell>
                <span className="text-2xl">
                  {cuenta["Tasa de Interés (TEA)"]}
                </span>
              </TableCell>
              <TableCell>
                <span className="text-xl">{cuenta["Mant"]}</span>
              </TableCell>
              <TableCell>
                <span className="text-xl">
                  {cuenta["Num Operaciones Libres - Ventanilla"]}
                </span>
              </TableCell>
              <TableCell>
                <span className="text-xl">
                  {cuenta["Num Operaciones Libres - Cajero Automático"]}
                </span>
              </TableCell>
              <TableCell>
                <span className="text-xl">
                  {cuenta["Monto Mínimo de Apertura"]}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
